







import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GSelector',
  props: {
    value: {
      type: Number as PropType<number>,
    },
    checked: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  methods: {
    onChange(e: Event): void {
      if (e.target instanceof HTMLInputElement) {
        this.$emit('change', e.target.value, e.target.checked);
      }
    },
  },
});
